import React, {
  useRef,
  useState,
} from 'react'

import './index.css'

const StatusPrint = ({
                       currentStatus,
                       options,
                       onSelectStatus,
                       className,
                       isReadOnly,
                       minWidth,
                       dataKey,
                       disabled,
                       colorless,
                     }) => {


  const selectRef = useRef(null)
  const [ isSelectOpen, setIsSelectOpen ] = useState(false)

  const getColor = (status) => {
    let prefix = 'jobs__status--'
    if (colorless) {
      return ''
    }
    switch (status) {
      case 'in progress':
      case 'scan_started':
      case 'scan_completed':
      case 'active':
        return `${prefix}in-progress`
      case 'scheduled':
        return `${prefix}scheduled`
      case 'completed':
      case 'suspended':
      case 'inactive':
        return `${prefix}completed`
      case 'canceled':
      case 'aborted':
      case 'deleted':
      case 'removed':
        return `${prefix}canceled`
      default:
        return ''
    }
  }

  const toggleSelect = (e) => {
    e.stopPropagation()
    setIsSelectOpen(!isSelectOpen)
    document.body.addEventListener('click', closeSelect)
  }

  const closeSelect = (e) => {
    if (!selectRef.current || !selectRef.current.contains(e.target)) {
      setIsSelectOpen(false)
      document.body.removeEventListener('click', closeSelect)
    }
  }

  const changeStatus = (option) => {
    onSelectStatus(option, dataKey)
    document.body.removeEventListener('click', closeSelect)
  }

  const optionsList = (
    !isReadOnly &&
    <ul className="options__list">
      {options.map(option => (
        <li className={`options__item ${getColor(option)}`} key={option} onClick={() => changeStatus(option)}>
          {option}
        </li>
      ))}
    </ul>
  )

  const isSelectable = () => {
    if (disabled) {
      return isReadOnly || disabled(currentStatus)
    } else {
      return isReadOnly
    }
  }

  return (
    <div

      readOnly={isReadOnly}
      className={`${className} table__row-item table__row-item--selectable table-select`}
      ref={selectRef}
    >
      <span
        className={'jobs__status--status ' + getColor(currentStatus)}
        style={minWidth ? { 'minWidth': minWidth } : null}
      >
        {currentStatus}

      </span>

    </div>
  )
}

export default StatusPrint


// import React, { useState, useRef } from 'react';
//
// import IconSelect from '../icons/IconSelect';
//
// import './index.css';
//
// const StatusPrint = ({
//                          currentStatus,
//                          className,
//                          minWidth,
//                        }) => {
//   console.log(currentStatus)
//   const selectRef = useRef(null);
//   const [isSelectOpen, setIsSelectOpen] = useState(false);
//
//   return (
//     <div
//
//       ref={selectRef}
//     >
//       <span
//
//         style={minWidth ? {'minWidth': minWidth} : null}
//       >
//         {currentStatus}
//       </span>
//
//     </div>
//   );
// }
//
// export default StatusPrint ;
